"use client";

import React from "react";
import styles from "./Agentic.module.scss";
import Image from "next/image";

function Agentic() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <div className={styles.tag}>
            <span>Innovation in Action</span>
          </div>
          <h2 className={styles.title}>
  What is Agentic
  <span className={styles.relative}>
     Commerce
    <span className={styles.iconWrapper}>
      <Image
        src="/agent-icons/sparkle.svg"
        alt="Sparkle Icon"
        width={12}
        height={12}
      />
    </span>
  </span>
  ?
</h2>

          <p className={styles.subtitle}>
            Agentic commerce represents the next evolution in e-commerce, where
            AI agents act autonomously to optimize every aspect of the customer
            journey.
          </p>
        </div>

        {/* Grid Content */}
        <div className={styles.grid}>
          {/* Left Column */}
          <div className={styles.content}>
            <div className={styles.block}>
              <h3 className={styles.heading}>Beyond Traditional E-commerce</h3>
              <p className={styles.text}>
                Traditional e-commerce relies on static product catalogs and
                manual processes. Agentic commerce introduces intelligent agents
                that continuously learn, adapt, and optimize the shopping
                experience in real-time.
              </p>
            </div>

            <div className={styles.block}>
              <h4 className={styles.subheading}>Key Characteristics</h4>
              <ul className={styles.list}>
                <li>
                  <Image
                    src="/features-icon2.webp"
                    alt="icon"
                    width={20}
                    height={20}
                  />
                  Autonomous decision-making capabilities
                </li>
                <li>
                  <Image
                    src="/features-icon2.webp"
                    alt="icon"
                    width={20}
                    height={20}
                  />
                  Continuous learning from customer interactions
                </li>
                <li>
                  <Image
                    src="/features-icon2.webp"
                    alt="icon"
                    width={20}
                    height={20}
                  />
                  Real-time personalization at scale
                </li>
                <li>
                  <Image
                    src="/features-icon2.webp"
                    alt="icon"
                    width={20}
                    height={20}
                  />
                  Proactive customer engagement
                </li>
              </ul>
            </div>
          </div>

          {/* Right Column */}
          <div className={styles.imageWrapper}>
            <Image
              src="https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&cs=tinysrgb&w=800"
              alt="AI Technology Visualization"
              width={800}
              height={534}
              className={styles.image}
            />
            <div className={styles.statusBox}>
              <div className={styles.statusContent}>
                <div className={styles.pulseDot} />
                <span className={styles.statusText}>AI Learning Active</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Agentic;
